import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

async function startMockServiceWorker() {
    if (!import.meta.env.DEV || import.meta.env.VITE_ENABLE_MOCKS !== 'true') {
        return;
    }

    const { worker } = await import('../mocks/browser');

    // Requests without a matching handler must reach the real API. That is also
    // what makes VITE_DISABLED_MOCKS work: a domain whose handlers are not
    // registered simply falls through to the real backend.
    await worker.start({
        // Unmatched requests must reach the real API. That is also what makes
        // VITE_DISABLED_MOCKS work: a domain whose handlers are not registered
        // falls through to the real backend.
        //
        // 'bypass' is deliberate over the default warning behaviour: the worker
        // replays unhandled requests through `fetch`, which breaks third-party
        // SDKs that rely on no-cors/opaque responses (Google Maps `gen_204`
        // beacons, which in turn fail Places with INVALID_REQUEST).
        onUnhandledRequest: 'bypass',
    });

    const disabled = import.meta.env.VITE_DISABLED_MOCKS;

    if (disabled) {
        console.info(`[msw] mocks disabled for: ${disabled}`);
    }
}

startMockServiceWorker().then(() => {
    startTransition(() => {
        hydrateRoot(
            document,
            <StrictMode>
                <HydratedRouter />
            </StrictMode>,
        );
    });
});
